import clsx from "clsx";
import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";

interface AccordionSectionProps {
    title: string;
    description?: string;
    defaultOpen?: boolean;
    children: React.ReactNode;
}

export default function AccordionSection({
    title,
    description,
    defaultOpen = false,
    children,
}: AccordionSectionProps) {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="overflow-hidden rounded-lg border border-slate-200 dark:border-slate-700">
            <button
                type="button"
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-3 bg-slate-50 px-4 py-3 text-left transition-colors hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700"
            >
                <span>
                    <span className="block text-sm font-semibold text-slate-900 dark:text-slate-100">
                        {title}
                    </span>
                    {description && (
                        <span className="block text-xs text-slate-500 dark:text-slate-400">
                            {description}
                        </span>
                    )}
                </span>
                <FiChevronDown
                    className={clsx(
                        "h-5 w-5 shrink-0 text-slate-500 transition-transform dark:text-slate-400",
                        open && "rotate-180",
                    )}
                />
            </button>
            {open && <div className="space-y-4 p-4">{children}</div>}
        </div>
    );
}
